/**
 * 顾问开单金额区间（元）。区间由超管在「顾问设置」里调，后端建单时才是真正的闸门；
 * 前端只用它限制输入框、给出提示。读不到（加载中 / 接口失败）时退回出厂默认——
 * 此时放行范围可能比实际略宽，但后端会二次校验并给出带实际区间的提示。
 */
import { useQuery } from '@tanstack/react-query';
import { getAdvisorOrderAmountRange } from '../../api/advisor';

/** 与后端 config/advisor-policy.ts 的出厂默认一致 */
export const FALLBACK_MIN_YUAN = 699;
export const FALLBACK_MAX_YUAN = 5000;

export const ORDER_AMOUNT_RANGE_KEY = ['advisor-order-amount-range'];

export function useOrderAmountRange(): { minYuan: number; maxYuan: number } {
  const query = useQuery({
    queryKey: ORDER_AMOUNT_RANGE_KEY,
    queryFn: getAdvisorOrderAmountRange,
    staleTime: 30_000,
    retry: false,
  });
  const range = query.data;
  return {
    minYuan: range ? range.minFen / 100 : FALLBACK_MIN_YUAN,
    maxYuan: range ? range.maxFen / 100 : FALLBACK_MAX_YUAN,
  };
}
